import { FC, ReactNode, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { UserPermissions } from '@enums/user-permissions';
import { AppRoutes } from '@routes/constants';
import { userPermissionsAtom } from '@store/atoms/userPermissions';

interface PermissionAcccessProps {
  hasPermission?: boolean;
  AllowedContent: ReactNode;
  DeniedContent?: ReactNode;
  permission?: UserPermissions;
  redirectIfNoAccess?: boolean;
  forceRedirectToNoAccess?: boolean;
}

const PermissionAccess: FC<PermissionAcccessProps> = ({
  hasPermission = false,
  AllowedContent,
  DeniedContent,
  permission,
  redirectIfNoAccess,
  forceRedirectToNoAccess = false,
}) => {
  const navigate = useNavigate();

  const permissions = useRecoilValue(userPermissionsAtom);
  const hasAccess =
    hasPermission || (permission && permissions?.includes(permission));

  useEffect(() => {
    if (forceRedirectToNoAccess || (!hasAccess && redirectIfNoAccess))
      navigate(AppRoutes.NO_ACCESS);
  }, [redirectIfNoAccess, hasAccess, forceRedirectToNoAccess]);

  return <>{hasAccess ? AllowedContent : DeniedContent}</>;
};

export default PermissionAccess;
